import axios from './HTTP'

export default {
  getAll (callback) {
    axios
      .get('/api/holidays.json')
      .then(response => ( callback(response.data) ))
  },

  create (params, callback, errorCallback) {
    axios
      .post(`/api/holidays.json`, {
        holiday: params
      })
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  },

  delete (id, callback, errorCallback) {
    axios
      .delete(`/api/holidays/${ id }.json`)
      .then(response => { callback(response.data) })
      .catch(error => { errorCallback(error) })
  }

}
